import {BindWalletParam, ModalWithHeaderProps} from "../../types/types";
import {ModalWithHeader} from "../../ui/Modal";
import React, {useEffect, useMemo, useState} from "react";
import {getWalletInitApi, getWalletNonceApi, loginByWalletApi, toBindWalletApi} from "../../api";
import {isSuccess} from "../../api/request";
import matchlog from "../../utils/matchlog";
import {useMatch} from "../../MatchContext";
import eventManager from "../../hooks/eventManager";
import {useIntl} from "react-intl";
import WalletModalContent from "../WalletModalContent";
import {useTRONWallet} from "../../hooks/useTRONWallet";
import {RecommendItem} from "../LoginBox";
import {BitgetIcon, OKXIcon, TronLinkIcon} from "../../assets/icon";
import {useDownMd} from "../../hooks/useLayout";
import {Button} from "../index";
type TRONConnectModalProps = ModalWithHeaderProps & {
    type?: 'login' | 'bind' | ''
    onSuccess?: () => void
}
function TRONConnectModal({
                                     type = 'login',
                                     onSuccess,
                                     ...props
                                 }:TRONConnectModalProps) {
    const isDownMd = useDownMd()
    const intl = useIntl()
    const {wallets, installedWallets, chooseWallet, wallet, address, onConnect} = useTRONWallet()
    const iconMaps = {
        tronlink: <TronLinkIcon size={isDownMd ? 36 : 40}/>,
        bitget: <BitgetIcon size={isDownMd ? 36 : 40}/>,
        okx:<OKXIcon size={isDownMd ? 36 : 40}/>
    }

    const {events, login} = useMatch()
    const [status, setStatus] = useState<'' | 'nonce' | 'signer' | 'success' | 'error'>('')
    const statusRef = React.useRef(status)
    const [error, setError] = useState('')
    const connected = useMemo(() => {
        return !!address
    }, [address])
    const disconnect = async () => {
        setStatus('')
        chooseWallet(null)
        statusRef.current = ''
        setError('')
    }

    const onBack = ()=>{
        setStatus('')
        chooseWallet(null)
        statusRef.current = ''
        setError('')
    }

    const toLoginInWallet = async () => {
        if (statusRef.current || !address || !wallet) return
        try {
            setStatus('nonce')
            statusRef.current = 'nonce'
            const res = type == 'bind' ? await getWalletInitApi({address,type:"TRON"}) : await getWalletNonceApi({address,type:"TRON"});
            if (!isSuccess(res)) {
                throw new Error(res.message)
            }
            const nonce = res.code >= 0 ? res.data.nonce : null;
            if (nonce) {
                setStatus('signer')
                statusRef.current = 'signer'
                const message = "By signing, you are proving you own this wallet and logging in. This does not initiate a transaction or cost any fees.Nonce:" + res.data.nonce;
                const signedMessage = await wallet.signMessage(message);
                let obj: BindWalletParam = {
                    type: 'TRON',
                    address: address,
                    signature: signedMessage,
                    message: message,
                    connector_type: 'TRON',
                    wallet_client_type: wallet.walletKey
                }
                const res1 = type == 'bind' ? await toBindWalletApi(obj) : await loginByWalletApi(obj)
                if (res1) {
                    if (!isSuccess(res1)) {
                        throw new Error(res1.message)
                    }
                    matchlog.log(res1)
                    setStatus('success')
                    statusRef.current = 'success'
                    if (type == 'bind') {
                        events!.onBind && events!.onBind({
                            type: 'tron'
                        })
                        eventManager.emit('onBind', {
                            type: 'tron'
                        })
                    } else {
                        await login({
                            // mid: res1.data.mid,
                            token: `${res1.data.token_type} ${res1.data.access_token}`
                        })
                    }
                    onSuccess && onSuccess()
                }
            }
        } catch (error: any) {
            // toast.error(error.message)
            // disconnect()
            setStatus('error')
            setError(error.message)
            statusRef.current = ''
        }
    }

    useEffect(() => {
        if (wallet) {
            console.log('onConnect')
            onConnect()
        } else {
            setStatus('')
        }
    }, [wallet]);

    useEffect(() => {
        if (address) {
            toLoginInWallet()
        }
    }, [address]);

    useEffect(() => {
        if (!props.isOpen) {
            disconnect()
        }
    }, [props.isOpen]);

    return <ModalWithHeader {...props} title={props.title || (intl.formatMessage({
        id: type == "bind" ? "bindWith" : "loginWith"
    }, {
        name: "TRON"
    }))} onBack={wallet ? onBack : undefined}>
        {
            wallet ? <WalletModalContent error={error} setError={setError} status={status} disconnect={disconnect}
                                         address={address || ''} connected={connected} visible setVisible={() => {
            }}/> : <div className="matchid-login-box">
                <div className="matchid-login-recommend-list">
                    {
                        installedWallets.map(wallet => {
                            return <RecommendItem
                                key={wallet.walletKey}
                                icon={iconMaps[wallet.walletKey as keyof typeof iconMaps]}
                                name={wallet.name} onClick={() => {
                                chooseWallet(wallet)
                            }}/>
                        })
                    }
                    {
                        wallets.filter(wallet => !installedWallets.find(installedWallet => installedWallet.walletKey == wallet.walletKey)).map(wallet => {
                            return <RecommendItem key={wallet.walletKey}
                                                  icon={iconMaps[wallet.walletKey as keyof typeof iconMaps]}
                                                  name={wallet.name} onClick={() => {
                            }}
                                                  footer={<Button size="sm" onClick={() => {
                                                      window.open(wallet.website)
                                                  }}>Install</Button>}/>
                        })
                    }


                </div>
            </div>
        }
    </ModalWithHeader>
}

export default function TRONModal(props: TRONConnectModalProps) {
    return props.isOpen&&<TRONConnectModal {...props} type={props.type}/>
}